import React,{ useState, useEffect,useRef, useCallback } from "react";

const useTimer = (initialSeconds = 180) => {
  const [seconds, setSeconds] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const timerRef = useRef(null);

  const startTimer = useCallback(() => {
    // Prevent starting if already running or timer is set
    if (isRunning) return;
    setSeconds(initialSeconds);
    setIsRunning(true);
    
    timerRef.current = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          setIsRunning(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  }, [initialSeconds, isRunning]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
      }
    };
  }, []);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const remainingSeconds = time % 60;
    return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
  };

  return {
    time: seconds,
    formattedTime: formatTime(seconds),
    startTimer,
    isTimerActive: isRunning,
    canResend: !isRunning && seconds === 0,
  };
};

export default useTimer;